module.exports = __webpack_public_path__ + "img/会员天地 手机端.1934cecf.jpg";